const OtherProjectsData = [
    [
        {
            id: 0,
            projectTitle: "IEEECS-VIT Official",
            projectDescription: "Official IEEECS-VIT website displaying information about the chapter's events, board members and contact information.",
            projectsTags: [
                "HTML",
                "CSS",
                "JavaScript"
            ],
            projectGithubLink: "https://github.com/SaranshM/IEEECS-Official-Website-2020",
            projectLink: "https://saranshm.github.io/IEEECS-Official-Website-2020/",
            projectLinkExist: true
        },
        {
            id: 1,
            projectTitle: "Smoking Data Analysis",
            projectDescription: "A web application to analyze and visualize the data pertaining to smoking and its effects around the world.",
            projectsTags: [
                "HTML",
                "CSS",
                "JavaScript",
                "ChartJS"
            ],
            projectGithubLink: "https://github.com/SaranshM/Smoking-Analysis-Visualization",
            projectLink: "https://saranshm.github.io/Smoking-Analysis-Visualization/",
            projectLinkExist: true
        },
        {
            id: 3,
            projectTitle: "Snake game",
            projectDescription: "Simple and basic snake game built on PyGame.",
            projectsTags: [
                "Python",
                "PyGame"
            ],
            projectGithubLink: "https://github.com/SaranshM/snake_game",
            projectLink: "#",
            projectLinkExist: false
        }
    ],
    [
        {
            id: 4,
            projectTitle: "WebXR - Gaseous State",
            projectDescription: "Simulation of the movement of gas molecules in a chamber using WebXR.",
            projectsTags: [
                "HTML",
                "WebXR"
            ],
            projectGithubLink: "https://github.com/SaranshM/WebXR-Gaseous-State",
            projectLink: "https://saranshm.github.io/WebXR-Gaseous-State/",
            projectLinkExist: true
        }
    ]
]

export default OtherProjectsData